import $ from 'jquery';
import _ from 'ext:lodash';
import UrlUtils from 'lib/url-utils';
import constants from 'lib/constants';
import localStorage from 'lib/local-storage';
import profileStore from 'framework/stores/ProfileStore';
import sessionStorage from 'lib/session-storage';
import formTracking from 'lib/form-tracking';
import Framework from 'framework';
import FormUtils from 'lib/form-utils';


$(() => {
	var formObj = $('#leadForm');
	var leadConfirmObj = $('.lead-confirmation');
	var isPrivateBrowsing = false;
	if(formObj.length > 0) {
		if(globalCrmWebhook){
			if(navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function(position) {
					window.currentLatitude = position.coords.latitude;
					window.currentLongitude = position.coords.longitude;
				});
			}
			console.log('Using CRM Webhook');
			formObj.on('submit', function(e) {
				e.preventDefault();
				if($(this).parsley().isValid() ) {
					const targetUrl = Framework.global.lt.api.apimUrl + globalCrmWebhook;
					let obj = FormUtils.serializerFormToJson(formObj);
					let mappedObj = FormUtils.mapFormObjecToCRM(obj);
					$.ajax({
						url: targetUrl,
						type: 'post',
						dataType: 'json',
						headers: {
							'Ocp-Apim-Subscription-Key': Framework.global.lt.api.apimKey
						},
						data: JSON.stringify(mappedObj),
						success: function (result) {
							window.location.href = crmConfirmationPath;
						},
						error: function(xhr, status, error){
							window.location.href = crmErrorPath;
						}
					});
				}
			});
		}
		var parsleyConfig = {
			trigger: 'change',
			errorClass: 'has-danger',
			classHandler: function (el) {
				return el.$element.closest('.form-group'); //working
			},
			errorsWrapper: '<ul class="label-help"></ul>'
		};
		$('#leadForm select#club').on('change', function() {
			$('[name=ltf_clubstatus]').val($(this).find(':selected').data('clubstatus'));
		});

		formObj.parsley(parsleyConfig);
		formObj.parsley().on('form:validated', function (e) {
			if(e.validationResult) {
				/* Validation has passed, prevent double form submissions */
				formObj.find('button[type=submit]').attr('disabled', true);
			}
		});
		// auto populate club field
		// use URL parameter if present
		let club = UrlUtils.getUrlParameter('clubId');

		if(club && club !== '') {
			$('#leadForm select#club').val(club);
		} else{
			// otherwise acquire club id from nearest club servlet
			$.get( '/bin/lt/nearestClubServlet', (data)=> {
				if(data) {
					let nearestClub;
					var types = $('[name="club_type').val();
					if(types){
						var typesArray = JSON.parse(types);
						$.each(data, function(index, c){
							if($.inArray(c.clubTypeId, typesArray) > -1){
								nearestClub = c.mmsClubId;
								return false;
							}
						});
					}else{
						nearestClub = data[0].mmsClubId;
					}
					if($('#leadForm select#club option[value="' + nearestClub + '"]').length > 0) {
						$('#leadForm select#club').val(nearestClub).trigger('change');
					}
				}
			});
		}
		// store public form data submitted in localStorage
		isPrivateBrowsing = checkSafariPrivateBrowsing();
		if(!isPrivateBrowsing) {
			$('#form-submit').on('click', ()=>{
				// create json object to store data
				let leadData = {};
				// collect public data
				leadData.firstName = formObj.find('#ltf_firstname').val();
				leadData.club = formObj.find('#club option:selected').text();
				// if club field was not visible, grab hidden input value
				if(leadData.club === '') {
					leadData.club = formObj.find('input[name="ltf_mmsclubid"]').data('club');
				}
				leadData.state = formObj.find('#club option:selected').parent().attr('label');
				leadData.birthYear = formObj.find('#ltf_birthyear option:selected').text();
				leadData.interests = [];
				_.forEach(formObj.find('input[name="interest_field"]:checked'), (f)=> {
					leadData.interests.push(f.value);
				});
				// put data in localStorage
				localStorage.set('leadFormData', leadData);
			});
		}
		// check for stored UTM data and set input values as needed
		checkStoredUtmData();
	}
	// replace confirmation page text with lead-specific information gathered from localStorage
	if(leadConfirmObj.length > 0) {
		var confirmText = leadConfirmObj.find('.lead-confirm-text').text();
		isPrivateBrowsing = checkSafariPrivateBrowsing();
		if(isPrivateBrowsing) {
			$('.lead-confirm-text').text('Thank you for your interest.');
		} else{
			var leadFormDataObj = localStorage.get('leadFormData');
			if(leadFormDataObj) {
				$('.lead-confirm-text').text(confirmText.replace('{{firstname}}', leadFormDataObj.firstName).replace('{{leadclub}}', leadFormDataObj.club));
			} else{
				$('.lead-confirm-text').text('Thank you for your interest.');
			}
		}
	}
	formTracking();
});

function checkSafariPrivateBrowsing() {
	try{
		// try to use localStorage
		localStorage.privacyCheck = 1;
	}catch(e) {
		return true;
	}
}

// check for stored utm data and update input fields with values
function checkStoredUtmData() {
	var utmParams = sessionStorage.get('utm_params');
	if(!_.isEmpty(utmParams)) {
		_.each(utmParams, (value, param)=> {
			$('input[name="ltf_utm' + param.substr(4) + '"]').val(value);
		});
	}
}
